// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { PAGE_NAMES, tagReferralsLink, tagReferralsPage } = require('utilities/taggingReferralsHelper');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const ReferralsPreview = require('components/referralsForm/referralsPreview/referralsPreview');

class ReferralsFormWithoutEmail extends React.Component {
    constructor(props) {
        super(props);

        this.handleSubmitCopyToClipboard = this.handleSubmitCopyToClipboard.bind(this);
        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handlePreviewClick = this.handlePreviewClick.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { onSubmit } = this.props;

        onSubmit();
        tagReferralsPage(this.getPageNameTag());
    }

    handleMainButtonClick() {
        const { onSubmit, handleReset } = this.props;

        handleReset();
        onSubmit();
    }

    handlePreviewClick() {
        const { onTogglePreview } = this.props;
        this.tagLinkEvent('previsualizar el mensaje');
        onTogglePreview();
    }

    handleBackClick() {
        this.tagLinkEvent('volver');
    }

    handleSubmitCopyToClipboard() {
        const { copyClipboardSuccess, immGlobalVariables, immSendReferrals, promotionCode, } = this.props;
        const immPromotions = immGlobalVariables.getIn(['variables', 'parameters', 'member_get_member_multi_promo', 'promotions']);
        const immPromotion = immPromotions.find(immPromotion => immPromotion.get('code') === promotionCode);

        if (!!immPromotion) {
            this.tagLinkEvent('copiar al portapapeles');
            sendTextToClipBoard(immPromotion.get('message_app').replace('%s', immSendReferrals.get('invitationCode')));
            copyClipboardSuccess();
        }
    }

    getPageNameTag() {
        const { immSendReferrals } = this.props;
        return `${PAGE_NAMES.CODE_SENDING_WITHOUT_MAIL} ${immSendReferrals.get('promoCode')}`;
    }

    tagLinkEvent(linkName) {
        tagReferralsLink(this.getPageNameTag(), linkName);
    }

    renderPreview() {
        const {
            promotionCode,
            immSendReferrals,
            isPreviewOpen,
            onTogglePreview,
        } = this.props;
        const contentModal = (
            <ReferralsPreview
                invitationCode={immSendReferrals.get('invitationCode')}
                promotionCode={promotionCode}
            />
        );

        return (
            <OKModal
                content={contentModal}
                isOpen={isPreviewOpen}
                onCloseCallback={onTogglePreview}
            />
        );
    }

    buildWizardSuccessCopied() {
        const goBackButton = {
            label: formatText('referrals-generateOtherCode').toUpperCase(),
        };

        return (
            <div className="col-xs-offset-1 col-xs-10">
                <WizardSuccess
                    successMessage={formatText('referrals-withoutEmailSuccessTitle')}
                    mainButton={goBackButton}
                    onMainButtonClick={this.handleMainButtonClick}
                >
                    <FormattedText value="referrals-withoutEmailSuccess" />
                </WizardSuccess>
            </div>
        );
    }

    buildWizardError() {
        const goBackButton = {
            label: formatText('referrals-returnToInviteFriend').toUpperCase(),
            url: '/myprofile/referrals'
        };

        return (
            <div className="col-xs-offset-1 col-xs-10">
                <WizardError
                    errorMessage={formatText('referrals-errorStepTitle')}
                    mainButton={goBackButton}
                >
                    <FormattedText
                        value="referrals-errorStepText"
                    />
                </WizardError>
            </div>
        );
    }

    buildWizardWithoutEmail() {
        const { immSendReferrals } = this.props;
        const previewContent = this.renderPreview();

        return (
            <div className="col-xs-12">
                {previewContent}
                <OKSectionBox>
                    <div className="row">
                        <div className="col-xs-12">
                            <h4 className="referrals-form-view__title">
                                <FormattedText value="referrals-sendCodePromotionTitle" />
                            </h4>
                            <p>
                                <FormattedText value="referrals-sendCodePromotionTextWithoutEmail" />
                            </p>
                            <p>
                                <OKButton
                                    onClick={this.handlePreviewClick}
                                    modifier="link-complementary"
                                >
                                    <FormattedText value="referrals-previewMessage" />
                                </OKButton>
                            </p>
                            <footer className="referrals-form-view__footer">
                                <div className="referrals-form-view__cancel-button">
                                    <OKLink
                                        modifier="inherit-styles"
                                        onClick={this.handleBackClick}
                                        to="/myprofile/referrals"
                                    >
                                        <FormattedText value="common-back" />
                                    </OKLink>

                                </div>
                                <OKButton
                                    onClick={this.handleSubmitCopyToClipboard}
                                    loading={immSendReferrals.get('isFetching')}
                                >
                                    <FormattedText value="referrals-copyToClipboard" />
                                </OKButton>
                            </footer>
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    render() {
        const { immSendReferrals } = this.props;


        let content;
        if (immSendReferrals.get('isFetching')) {
            content = (
                <div className="col-xs-12">
                    <OKSectionBox>
                        <LoadingSection />
                    </OKSectionBox>
                </div>
            );
        }
        else if (immSendReferrals.get('errorReceived') || (immSendReferrals.get('submitSuccessful') && !immSendReferrals.get('invitationCode')) ) {
            content = this.buildWizardError();
        }
        else if(immSendReferrals.get('clipboardCopied')) {
            content = this.buildWizardSuccessCopied();
        }
        else {
            content = this.buildWizardWithoutEmail();
        }

        return content;
    }
}

ReferralsFormWithoutEmail.propTypes = {
    copyClipboardSuccess: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immSendReferrals: PropTypes.object.isRequired,
    isPreviewOpen: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onTogglePreview: PropTypes.func.isRequired,
    promotionCode: PropTypes.string.isRequired,
};

module.exports = ReferralsFormWithoutEmail;
